export const validateReviewQuestion = (question) => {
  // check for falsy value and empty object {}
  if (!question || typeof question !== 'object' || Object.keys(question).length === 0) {
    return false;
  }

  const { answerType, answerOptions, hasCustomDescription, description } = question;
  // check for question description in case of non variant question.
  if (!hasCustomDescription && !description) {
    return false;
  }

  // answer type based validation
  if (answerType === 'DROP_DOWN') {
    // validate answer options, all answer options must have description
    if (!Array.isArray(answerOptions) || answerOptions.length === 0) {
      return false;
    }
    const hasEmptyOption = answerOptions.some((option) => !option.description);
    if (hasEmptyOption) {
      return false;
    }
    // need to check score here only as it's editable in this answer type
    const hasValidScore = answerOptions.every(
      (option) => option.score !== undefined && option.score !== null && option.score !== ''
    );
    if (!hasValidScore) {
      return false;
    }
  }

  if (answerType === 'NUMBER_RATING') {
    // validate answer options, all answer options must have description
    if (!Array.isArray(answerOptions) || answerOptions.length === 0) {
      return false;
    }
    // first and last options must have description
    if (!answerOptions[0].description || !answerOptions[answerOptions.length - 1].description) {
      return false;
    }
  }

  return true;
};
